import { useEffect, useState } from "react";

const useIsTaboolaEnabled = (): boolean => {
  const [isTaboolaEnabled, setIsTaboolaEnabled] = useState<boolean>(true);

  useEffect(() => {
    if (typeof window === "undefined") return;

    // Initial check
    setIsTaboolaEnabled(window.taboola_enable !== 0);

    console.log("[TABOOLA] Initial value:", window.taboola_enable); // eslint-disable-line no-console
    // Set up polling to check for changes
    const interval = setInterval(() => {
      const newValue = window.taboola_enable !== 0;

      if (newValue !== isTaboolaEnabled) {
        console.log("[TABOOLA] Value changed:", window.taboola_enable); // eslint-disable-line no-console
        setIsTaboolaEnabled(newValue);
      }
    }, 5000); // Check every second

    // Cleanup interval on unmount
    return () => {
      clearInterval(interval);
    };
  }, [isTaboolaEnabled]);

  return isTaboolaEnabled;
};

export default useIsTaboolaEnabled;
